var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fb335db0edd1dfcb796b4c3df4129bcf06ee1488"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["alobyte-eg@alobyte-eg"]={id:"fb335db0edd1dfcb796b4c3df4129bcf06ee1488"};
      